import { fetchImages, setOption } from "../../../sections/Helpers";

export default {
  state: {
    selection: {},
    defaultSelection: "",
    options: [],
  },

  mutations: {
    setSelection(state, selection) {
      state.selection = selection;
    },

    setDefaultSelection(state, defaultSelection) {
      state.defaultSelection = defaultSelection;
    },

    setOptions(state, options) {
      state.options = options;
    },
    setOption,
  },

  actions: {
    fetchImages,
  },
};
